import React, { useState } from 'react';
import { Modal, useResponsiveParams } from 'quanta-ui';
import SmartSearchPanelTwoWheeler from './smart-search-two-wheeler';
// import SmartSearchPanelHealth from './smart-search-health';

export default function ImportQuoteModal({
  copyQuoteDisplay,
  setCopyQuoteDisplay,
  setMoveToPlans,
  category,
  productName,
  productCode,
  ...props
}) {
  const { voice } = props;
  const [alerts, setAlerts] = useState([]);

  const modalSize = useResponsiveParams({
    for_mobile: 'full',
    for_desktop: 'full',
    for_iPad: 'full',
  });

  const onModalClose = () => {
    setCopyQuoteDisplay(false);
    document.body.classList.remove('overflow-y-hidden');
  };

  return (
    <Modal
      display={copyQuoteDisplay}
      size={modalSize}
      title={'Import Quote'}
      className="min-h-screen flex flex-col justify-start"
      onClose={onModalClose}
      severity={'action'}
      direction={'down'}
    >
      <SmartSearchPanelTwoWheeler
        {...{
          alerts,
          setAlerts,
          voice,
          setCopyQuoteDisplay,
          setMoveToPlans,
          category,
          productName,
          productCode
        }}
      />
    </Modal>
  );
}
